var _defs, _path, _path2, _path3, _polygon, _ellipse, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgITechLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1155.33 581.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f8fcd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M968.61,306.58l-33.99,98.18h-69.47l31.83-88.92c2.47-11.12-10.15-15.35-13.22-15.57-14.9-1.08-31.65,8.05-36.46,22.2l-28.95,82.29h-69.47l80.16-226.92h69.47l-32.2,91.68c16.36-14.82,47.02-25.61,67.09-25.61,29.95,0,43.84,21.61,35.2,62.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M588.49,356.02c8.05-3.01,16.25-6.75,24.86-10.5-3.79,8.61-8.68,16.63-14.66,24.12-12.32,15.92-31.06,28.65-51.25,33.03-57,13.55-105.96-32.4-91.3-90.66,17.44-69.14,115.83-93.89,157.58-32.4,2.64,4.16,4.94,10.21,4.75,15.44.07,6.94-3.6,14.66-9.43,18.37-27.76,16.18-56.19,31.1-86.81,41.49,12.1-19.74,26.24-37.89,41.34-55.22-26.05-5.49-58.53,17.26-50.73,44.83,3.86,11.84,18.63,16.55,31.03,18.37,15.36,2,29.65-1.37,44.61-6.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.88,405.13h-69.14l57.09-162.84h-48l23.42-65.14h169.12l-22.42,65.14h-51.99l-58.09,162.84Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "248.81 409.07 183.33 409.19 241.91 244.86 307.39 244.75 248.81 409.07"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 293.12,
    cy: 192.75,
    rx: 44.96,
    ry: 32.83,
    transform: "translate(-56 227.18) rotate(-38.96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.29,290.98c17.13-25.13,47.12-46.46,76.07-46.21,66.19.56,56.69,54.52,56.69,54.52,0,0-83.01-47-111.33,38.21,0,0-15.19-.66-23.06-13.78-6.48-10.81-1.18-28.62,1.62-32.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.18,298.61s-14.03,29.59,18.91,41.78c23.56,8.72,46.81-10.91,46.81-10.91l12.22,15.87s-27.99,26.45-59.03,15.71c-31.65-10.96-34.97-39.1-18.91-62.45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.66,334.49s8.25,34.36,42.42,35.01c46.2.88,63.24-28.98,65.74-32.74l11.67,10.07s-13.41,29.41-55.36,37.03c-23.6,4.29-68.49-3.03-64.47-49.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.41,369.84s23.96,27.9,61.02,19.93c25.72-5.53,53.05-18.31,64.11-54.86l6.45,8.18s-5.72,27.59-31.09,44.67c-25.31,17.04-61.67,16.99-79.95,6.59-14.08-8.01-20.55-24.51-20.55-24.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITechLogo);
export default __webpack_public_path__ + "static/media/iTechLogo.8b0e972092f1e770725edec5de042885.svg";
export { ForwardRef as ReactComponent };